export default {
  wageData: state => state.wageData,
  medicalStaff: state => state.medicalStaff,
  revenueTypeOptions: state => state.revenueTypeOptions,
}
